import { FC, useState } from "react";
import {Alert, useMediaQuery, useTheme, Tooltip} from "@mui/material";
import { StyledIconButton } from "@/components/styled";
import SVGEmail from "@/assets/icons/SVGEmail.tsx";
import {sendPerformanceReportEmailReq} from "@/api/projectsApi";
import Snackbar from "@mui/material/Snackbar";

type NotificationMessage = {
    message: string;
    severity: "error" | "success";
}

type Props = {
    projectId: number;
    performanceReportId: number;
    quarterName: string | null;
    performanceYear: number | null;
};

const SendPerformanceReportEmail: FC<Props> = ({ projectId, performanceReportId, quarterName, performanceYear }) => {
    const [notificationMessage, setNotificationMessage] = useState<NotificationMessage | null>(null);
    const theme = useTheme();
    const downSm = useMediaQuery(theme.breakpoints.down("sm"));

    const isSendPerformanceReportEmail = quarterName && performanceYear;

    const handleCloseNotification = () => {
        setNotificationMessage(null);
    }

    const handleSendPerformanceReportEmail = async () => {
        try {
            const response = await sendPerformanceReportEmailReq({
                projectId,
                performanceReportId,
            });
            setNotificationMessage({
                message: response?.data?.message,
                severity: "success",
            });
        } catch (e: any) {
            setNotificationMessage({
                message: e?.response?.data?.error || "An unexpected error occurred.",
                severity: "error",
            });
        }
    };

    return (
        <>
            <Tooltip
                title={downSm ? "" : "Send Performance Incentive Email"}
                arrow
                placement="top"
            >
                <StyledIconButton
                    sx={{
                        ...(downSm && { flex: 1 }),
                        ...(!isSendPerformanceReportEmail && { opacity: 0.5 })
                    }}
                    onClick={handleSendPerformanceReportEmail}
                    variant={!downSm ? "text" : "outlined"}
                    disabled={!isSendPerformanceReportEmail}
                >
                    {!downSm ? <SVGEmail color={!isSendPerformanceReportEmail ? theme.palette.textGray3 : "#1976d2"} /> : "Send Performance Incentive Email"}
                </StyledIconButton>
            </Tooltip>

            {notificationMessage && (
                <Snackbar
                    open={Boolean(notificationMessage)}
                    autoHideDuration={6000}
                    onClose={handleCloseNotification}
                >
                    <Alert onClose={handleCloseNotification} severity={notificationMessage?.severity}>
                        {notificationMessage?.message}
                    </Alert>
                </Snackbar>
            )}
        </>
    );
};

export default SendPerformanceReportEmail;